import Vue from 'vue'
import VueI18n from 'vue-i18n'
// 引入语言文件
// Miracle项目
import zh_CN from './MUI/Miracle/zh' // 中文
import zh_TW from './MUI/Miracle/zhTW' // 繁体
import en from './MUI/Miracle/en'
import ko from './MUI/Miracle/ko'
import ja from './MUI/Miracle/ja'
import ru from './MUI/Miracle/ru'




Vue.use(VueI18n)


const name = process.env.VUE_APP_PROJECT_NAME

const messages = { // 存放语言包
  // 项目名称
  "SIBI": {
    zh_CN,
    zh_TW,
    en,
    ko,
    ja,
    ru,
  },

}

const i18n = new VueI18n({ // 实例化VueI18n
  locale: localStorage.getItem('SET_LANGUAGE') || 'zh_CN', // 默认英语、开发使用中文
  messages: messages[name], // 语言包
  silentTranslationWarn: true, // 去掉翻译警告
})


export default i18n